import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { getAllAnswers } from '@utils/onboardingStorage'
import { useTranslation } from 'react-i18next'

export default function PersonalizedPlanPage() {
  const { t } = useTranslation()
  const allAnswers = getAllAnswers()
  const goalsAnswer = allAnswers.goals?.answer ?? ''
  const isClarityGoal =
    goalsAnswer === 'Clear my mind' || goalsAnswer === 'Make more space'

  const headingKey = isClarityGoal
    ? 'pages.onboarding.v1.personalizedPlan.clarity.heading'
    : 'pages.onboarding.v1.personalizedPlan.general.heading'
  const textKey = isClarityGoal
    ? 'pages.onboarding.v1.personalizedPlan.clarity.text'
    : 'pages.onboarding.v1.personalizedPlan.general.text'

  return (
    <FeedbackPage
      emoji="📋"
      heading={t(headingKey)}
      text={t(textKey)}
      onSubmit={() => {}}
    />
  )
}
